export const headers = [
  { field: "id", headerName: "ID", width: 24, hidden: true },
  { field: "descripcion", headerName: "Descripcion", width: 230 },
  { field: "estado", headerName: "Estado", width: 230 },
  ];
  